import { inject, Injectable, NgZone } from '@angular/core';
import { EAudioPlayStatusType } from '@type/enums/mobile';

@Injectable({
  providedIn: 'root'
})
export class AudioControllerService {

  private nz = inject(NgZone)

  public audio: any
  public urls: string[] = []
  public isReading: boolean = false
  // 语音朗读状态
  public volumnStatus: EAudioPlayStatusType = EAudioPlayStatusType.ON
  // 最后一条文本回复是否完成
  public lastReplyTextIsFinish: boolean = true

  private animationId: number = 0

  constructor() {
    this.audio = new Audio()
    this.audio.speed = 0.3
  }

  start() {
    this.volumnStatus = EAudioPlayStatusType.READING
    this.isReading = true

    this.animationId = window.setInterval(() => {
      this.getUrl()
    }, 10)
  }

  end() {
    clearInterval(this.animationId)
  }

  async play(url: string) {
    await new Promise<void>((resolve) => {
      this.audio.src = url

      this.audio.onended = () => {
        // 播放完成
        this.audio.onended = null
        resolve()
      }

      this.audio.currentTime = 0
      this.audio.play()
    })

    // 保证最后一条还没推入数组并且当前数组不为空则执行
    if (this.lastReplyTextIsFinish && !this.urls.length) {
      this.nz.run(() => { this.volumnStatus = EAudioPlayStatusType.ON })
      this.isReading = false
      return
    }

    this.start()
  }

  addUrl(url: string) {
    this.urls.push(url)
  }

  // 获取播放地址
  getUrl() {
    if (this.lastReplyTextIsFinish && !this.urls.length && this.isReading) {
      this.end()
      this.isReading = false
      this.nz.run(() => { this.volumnStatus = EAudioPlayStatusType.ON })
      return
    }
    this.volumnStatus = EAudioPlayStatusType.READING
    this.isReading = true

    const url = this.urls.shift()
    if (url) {
      this.play(url)
      this.end()
      this.isReading = false
    }
  }

}
